const getBaseAPI = () => {
  const origin = window.location.origin;
  const env = process.env.REACT_APP_ENV;

  const apiUrlFromMetaTag =
    document.querySelector("meta[name='api-url']")?.getAttribute("content") ??
    "{{apiUrl}}";

  let baseUrl =
    apiUrlFromMetaTag === "{{apiUrl}}"
      ? process.env.REACT_APP_BASEURL
      : apiUrlFromMetaTag;

  if (
    !origin.includes("monkey-tie") &&
    process.env.REACT_APP_GOM !== "true" &&
    !origin.includes("localhost") &&
    apiUrlFromMetaTag === "{{apiUrl}}"
  ) {
    const split = origin.split(".");
    split[0] = `https://mtback-${env}`;
    baseUrl = split.join(".") + "/api/";
  }

  return baseUrl!;
};

export default getBaseAPI;
